import React from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';


interface IProps extends ICellProps {
    edited?: boolean;
    index_value?: any;
};


const DataBlock = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    background-color:#eee;
    font-size:12px;
    font-weight: bold;
    align-items: center;
    padding: 0 10px;
`;

const TextInput = styled.input`
    position: absolute;
    display: block;
    top:0;
    left:0;
    margin: 0;
    height: 100%;
    width: 100%;
    border: none;
    padding: 0;
    box-sizing: border-box;
    outline: none;
    padding: 0 10px;
`;

const Index: React.FC<IProps> = (props: IProps) => {
    if (props.edited && !props.value) {
        return <TextInput {...props} value={props.index_value || ''} onChange={(e) => {
            const value = e.target.value.replace(/\D/ig, '');
            props.onChange && props.onChange(value)
          }} />
    }
    return <DataBlock>{props.value}</DataBlock>;
}

export default Index;